import { Button } from '@mui/material';

import { useMutation, useQuery } from 'react-query';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


import { deleteYoutubeLinkeByIdFn, getYoutubeLinkFn } from '../../../Services/Youtube';
import ReactPlayer from 'react-player'


const YoutubeLink = () => {
    const navigate = useNavigate();

    const { state } = useLocation()
    const { data: getGalleryImage, refetch } = useQuery({
        queryKey: ["get_video_link", state?.video_id],
        queryFn: () => getYoutubeLinkFn({ video_id: state?.video_id }),

        enabled: Boolean(state?.video_id)
    })

    const { mutate: deleteGalleryImage } = useMutation(deleteYoutubeLinkeByIdFn, {
        onSuccess: () => {
            refetch();
            toast.success("Video deleted successfully.")
        }
    })

    const handleDelete = (id) => {
        const formData = new FormData();
        formData.append("video_url_id", id);
        deleteGalleryImage(formData);
    }

    return (
        <>
            <p className="my-3 text-5xl text-center text-blue-900 underline">
                Youtube {state?.title} Page Videos
            </p>
            <div className="flex justify-end item-center w-[100%]">
                <div onClick={() => navigate("/youtube-links/add", {
                    state: {
                        video_id: state?.video_id
                    }
                })} >
                    <div className="text-xl font-bold !text-gray-600 p-3 pr-[10%]">
                        <Button variant="outlined">Add</Button>
                    </div>
                </div>
            </div>
            <div className="grid justify-between md:grid-cols-2 lg:grid-cols-4 gap-3">
                {getGalleryImage?.data?.data.map((item) => {
                    return (
                        <div
                            key={item.id}
                            className="flex flex-col gap-4 p-4 mx-3 my-4 border border-gray-300 rounded-lg shadow-lg w-full max-w-[600px] mx-auto"
                        >
                            {/* Title */}
                            <p className="text-lg font-semibold text-gray-800">{item.title}</p>

                            {/* Video */}
                            <div className="w-full">
                                <ReactPlayer
                                    src={item.url}
                                    width="100%"          // Ensures responsiveness
                                    height="300px"        // Or use 225px for smaller height
                                    controls
                                />
                            </div>

                            {/* Buttons */}
                            <div className="flex justify-center gap-4 mt-4">
                                <Button
                                    onClick={() =>
                                        navigate(`/youtube-links/update`, {
                                            state: {
                                                link_id: item.id,
                                                video_id: state?.video_id
                                            },
                                        })
                                    }
                                    variant="outlined"
                                >
                                    Update
                                </Button>

                                <Button
                                    onClick={() => handleDelete(item.id)}
                                    variant="outlined"
                                    color="error"
                                >
                                    Delete
                                </Button>
                            </div>
                        </div>


                    );
                })}
            </div>
        </>
    )
}

export default YoutubeLink;